var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.mostrarBtnDesassociarDespViagem)?_c('span',{staticClass:"text-danger"},[_c('i',{staticClass:"fa fa-trash fa-lg icon-button",attrs:{"title":"Desassociar Despesa de Viagem"},on:{"click":function($event){$event.stopPropagation();return _vm.confirmarDesassociarDespViagem(
                _vm.finalizacaoDespViagem.finalizacaoDespViagemId
            )}}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }